import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { TreeCardObject } from 'src/app/models/products/tree-card/tree-card-object.model';
import { Product } from 'src/app/models/interface/product/product';
import { ProductTypeObject } from 'src/app/models/products/product-type-object.model';
import { ProductObject } from 'src/app/models/products/product/product-object.model';
import { CfsObject } from 'src/app/models/products/cfs/cfs-object.model';
import { RfsObject } from 'src/app/models/products/rfs/rfs-object.model';
import moment from 'moment';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss']
})
export class TreeComponent implements OnInit {

  private _item: Product;
  @Input()
  get item(): any {
    return this._item;
  }
  set item(value: any) {
    this._item = value;
    if (this._params) {
      this.ngOnInit();
    }
  }

  private _params: any;
  @Input()
  get params(): any {
    return this._params;
  }
  set params(value: any) {
    this._params = value;
    if (this._item) {
      this.ngOnInit();
    }
  }

  treeCards: Array<TreeCardObject>;

  constructor(private appService: AppService) {

  }

  ngOnInit() {
    this.loadTree(this.item);
  }


  private loadTree(item: Product) {
    this.treeCards = [];
    const productObject = new ProductObject(
      item.name, item.productState === 'ACTIVATED', null, null, item.productState, false, 0, item.id.toString(), item.specId
    );
    if (!this.params.type || this.params.type === 'product') {
      productObject.setClicked(true);
    }

    this.treeCards.push(productObject);

    let cfsIndex: number;
    let rfsIndex: number;

    cfsIndex = 0;
    rfsIndex = 0;

    for (const cfs of item.cfses) {
      const cfsObject = new CfsObject(
        cfs.name, cfs.operationalState === 'ACTIVATED', null, null, cfs.operationalState, false, cfs.id, item.id.toString(), cfs.specId
      );
      if (this.params.type === 'cfs' && cfs.id === +this.params.map) {
        cfsObject.setClicked(true);
      }

      this.treeCards.push(cfsObject);
      cfsIndex++;

      if (item.domainName === 'FTTH') {
        cfs.rfses.sort((x, y) => {
          return moment(x.createdAt, this.appService.settings.dateFormat)
                              .diff(moment(y.createdAt, this.appService.settings.dateFormat));
        });
      }
      else {
        cfs.rfses.sort((x, y) => {
          return y.specId > x.specId ? -1 : 1;
        });
      }
      

      for (const rfs of cfs.rfses) {
        const rfsObject = new RfsObject(
          rfs.name, rfs.operationalState === 'ACTIVATED', null, null, rfs.operationalState, false, rfs.id, item.id.toString(), rfs.specId
        );
        if (this.params.type === 'rfs' && rfs.id === +this.params.map) {
          rfsObject.setClicked(true);
        }

        this.treeCards.push(rfsObject);
        rfsIndex++;
      }
    }

  }

  onClickCard($event: TreeCardObject) {
    this.setSelectedTreeCard($event.getMapping(), $event.getType());
  }

  setSelectedTreeCard(mapping: number, type: ProductTypeObject) {
    for (let treeCard of this.treeCards) {
      if (treeCard.getMapping() === mapping && treeCard.getType().equals(type)) treeCard.setClicked(true);
      else treeCard.setClicked(false);
    }
  }

}
